import { useContext } from 'react';
import { IProfile } from '@comptia-sso/core';
import { CertMasterPlatformLinkAccountContext } from '../CertMasterPlatformLinkAccount/CertMasterPlatformLinkAccountContext';
import { useTranslation, Trans } from 'react-i18next';
import styles from './AccessYourTraining.module.scss';

type Props = {
  profile: IProfile;
};

export function InformationText({ profile }: Props) {
  const isLinked = profile?.externalIds?.certMaster != null;
  const { t } = useTranslation();
  const context = useContext(CertMasterPlatformLinkAccountContext);

  return (
    <>
      <p>
        <Trans
          i18nKey="InfoText.AccessKeys"
          components={{
            linktag: (
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={process.env.REACT_APP_COMPTIA_PLATFORM_HOST}
              />
            ),
          }}
        />
      </p>
      {!isLinked && (
        <p>
          <Trans
            i18nKey="InfoText.Unlinked"
            components={{
              linktag: (
                <a
                  href={t('Links.LegacyAccount')}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              linktag2: (
                <a
                  className={styles.linkYourAccount}
                  onClick={() => context?.setIsLinking(true)}
                />
              ),
            }}
          />
        </p>
      )}
    </>
  );
}
